import React from 'react';
import { isMobileOnly, isIOS } from 'react-device-detect';

export const useIsMobile = () => isMobileOnly;
export const useIsIOSDevice = () => isIOS;

export interface IsMobileWrapperProps {
    children: (isMobile: boolean) => React.ReactNode;
}

export const IsMobileWrapper = ({ children }: IsMobileWrapperProps) => {
    const isMobile = useIsMobile();
    return <>{children(isMobile)}</>;
};
